import { useCallback, useEffect, useState } from "react";
import { fetchDashboard } from "../services/analyticsService";
import axiosInstance from "../lib/axios";

export default function useDashboardData() {
  const [data, setData] = useState(null);
  const [meta, setMeta] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const loadDashboard = useCallback(async () => {
    try {
      setLoading(true);
      setError("");

      const result = await fetchDashboard();
      setData(result?.data || null);
      setMeta(result?.meta || null);
    } catch (err) {
      setError(err.message || "Something went wrong while loading dashboard");
    } finally {
      setLoading(false);
    }
  }, []);

  const refreshDashboard = async () => {
    const response = await axiosInstance.get("/analytics/refresh");

    if (response.status === 200){
      // onRefreshCompleted()
    }
  }

  useEffect(() => {
    loadDashboard();
  }, [loadDashboard]);

  return {
    data,
    meta,
    loading,
    error,
    refetch: loadDashboard,
    refreshDashboard
  };
}
